var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.count > 0)?_c('v-badge',{staticClass:"mt-2",attrs:{"color":"accent"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [(_vm.count > 0)?_c('span',[_vm._v(_vm._s(_vm.count))]):_vm._e()]},proxy:true}],null,false,1912552415)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }